// extracted by mini-css-extract-plugin
module.exports = {"slide":"swiper_slide__IFC1a","slide-l":"swiper_slide-l__SEANJ","slide-m":"swiper_slide-m__JAVst","img":"swiper_img__dbwaE","plate":"swiper_plate___0MkI"};